import React, { useRef, useState } from "react"
import "./Footer.css"
import Logo from "../assets/Logo.jpg"
import { Link, useNavigate } from "react-router-dom"
import {
  FaFacebook,
  FaTwitter,
  FaInstagram,
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
  FaLinkedin,
} from "react-icons/fa"
import emailjs from "@emailjs/browser"

function Footer() {
  const navigate = useNavigate()
  const formRef = useRef(null)
  const [sending, setSending] = useState(false)
  const [status, setStatus] = useState(null)

  const handleLogoClick = () => {
    navigate("/")
    window.scrollTo(0, 0)
  }

  const handleSubscribe = async (e) => {
    e.preventDefault()
    if (!formRef.current) return
    setSending(true)
    setStatus(null)
    const serviceId = process.env.NEXT_PUBLIC_EMAILJS_SERVICE_ID
    const templateId = process.env.NEXT_PUBLIC_EMAILJS_TEMPLATE_ID
    const publicKey = process.env.NEXT_PUBLIC_EMAILJS_PUBLIC_KEY
    try {
      await emailjs.sendForm(serviceId, templateId, formRef.current, publicKey)
      setSending(false)
      setStatus({ ok: true, text: "Subscribed — check your email for confirmation." })
      formRef.current.reset()
    } catch (err) {
      setSending(false)
      setStatus({ ok: false, text: "Subscription failed. Please try again later." })
    }
  }

  return (
    <footer id="contact" className="footer">
      <div className="footer-container">
        <div className="footer-about" onClick={handleLogoClick} style={{ cursor: "pointer" }}>
          <img src={Logo || "/placeholder.svg"} alt="Pramila Foundation Logo" className="footer-logo" />
          <h3>Pramila Foundation</h3>
          <p>Service for a Better Society</p>
          <p>Reg. No: 21 of 2022</p>
        </div>

        <div className="footer-links">
          <h3>Quick Links</h3>
          <ul>
            <li>
              <Link to="/" onClick={() => window.scrollTo(0, 0)}>
                Home
              </Link>
            </li>
            <li>
              <Link to="/about" onClick={() => window.scrollTo(0, 0)}>
                About
              </Link>
            </li>
            <li>
              <Link to="/our-team" onClick={() => window.scrollTo(0, 0)}>
                Our Team
              </Link>
            </li>
            <li>
              <Link to="/gallery" onClick={() => window.scrollTo(0, 0)}>
                Gallery
              </Link>
            </li>
            <li>
              <Link to="/articles" onClick={() => window.scrollTo(0, 0)}>
                Articles
              </Link>
            </li>
            <li>
              <Link to="/annual-reports" onClick={() => window.scrollTo(0, 0)}>
                Annual Reports
              </Link>
            </li>
          </ul>
        </div>

        <div className="footer-contact">
          <h3>Contact Us</h3>
          <ul>
            <li>
              <FaMapMarkerAlt /> <span>Pramila Foundation, Narayanpet, Telangana</span>
            </li>
            <li>
              <FaPhone /> <span>+91 8099079118</span>
            </li>
            <li>
              <FaEnvelope /> <span>pramilafoun@gmail.com</span>
            </li>
          </ul>
          <div className="social-icons">
            <a
              href="https://www.facebook.com/share/1Go3N4X2MV/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <FaFacebook />
            </a>
            <a
              href="https://x.com/pramilafoun?t=rELb4h2tsAo3wh1KlpBhNw&s=09"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="X / Twitter"
            >
              <FaTwitter />
            </a>
            <a
              href="https://www.instagram.com/pramilafoundtaion/#"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <FaInstagram />
            </a>
            <a
              href="https://www.linkedin.com/in/pramila-foundation-a7000a231/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <FaLinkedin />
            </a>
          </div>
        </div>

        <div className="footer-newsletter">
          <h3>Join Our Newsletter</h3>
          <p>Stay updated with our latest news and events</p>
          <form ref={formRef} className="newsletter-form" onSubmit={handleSubscribe}>
            <input type="text" name="user_name" placeholder="Your Name" required />
            <input type="email" name="user_email" placeholder="Your Email Address" required />
            <input type="hidden" name="source" value="Footer Newsletter" />
            <button type="submit" disabled={sending}>
              {sending ? "Subscribing..." : "Subscribe"}
            </button>
          </form>
          {status && <p className={`newsletter-status ${status.ok ? "ok" : "error"}`}>{status.text}</p>}
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Pramila Foundation. All Rights Reserved.</p>
      </div>
    </footer>
  )
}

export default Footer
